import React from 'react';
import { Award, Shield, Sparkles, TrendingUp } from 'lucide-react';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// ============ Helpers ============

// Map département FR (2 premiers chiffres CP) → territoire (DOM-TOM + métropole).
export const DOM_TOM_CODES = {
  '971': 'Guadeloupe', '972': 'Martinique', '973': 'Guyane',
  '974': 'La Réunion', '975': 'Saint-Pierre-et-Miquelon', '976': 'Mayotte',
  '977': 'Saint-Barthélemy', '978': 'Saint-Martin', '986': 'Wallis-et-Futuna',
  '987': 'Polynésie française', '988': 'Nouvelle-Calédonie',
};

export function detectTerritoire(cooper) {
  if (cooper.territoire) return String(cooper.territoire);
  const addr = String(cooper.adresse_siege || cooper.adresse || cooper.code_postal || '');
  // DOM-TOM (CP 5 chiffres commençant par 9)
  const m3 = addr.match(/\b(97[1-8]|98[678])\d{2}\b/);
  if (m3) return DOM_TOM_CODES[m3[1]] || 'Outre-Mer';
  const m2 = addr.match(/\b(\d{2})\d{3}\b/);
  if (m2) {
    const dep = m2[1];
    if (dep === '20') return 'Corse';
    return 'Métropole';
  }
  return 'Non renseigné';
}

export function detectPlan(cooper) {
  return String(cooper.plan || cooper.formule || cooper.subscription_plan || 'Standard');
}

export function ageInDays(iso) {
  if (!iso) return 0;
  const d = new Date(iso).getTime();
  if (Number.isNaN(d)) return 0;
  return Math.floor((Date.now() - d) / (24 * 3600 * 1000));
}

export function anciennetéBucket(days) {
  if (days < 30) return 'new';
  if (days < 90) return 'recent';
  if (days < 365) return 'established';
  return 'veteran';
}

export const ANCIENNETE_LABELS = {
  new: { label: '< 30 jours', dot: 'bg-emerald-500', icon: Sparkles },
  recent: { label: '30 — 90 jours', dot: 'bg-sky-500', icon: TrendingUp },
  established: { label: '3 — 12 mois', dot: 'bg-[#DEA900]', icon: Award },
  veteran: { label: '> 1 an', dot: 'bg-[#0a3d62]', icon: Shield },
};

// Génère un avatar initiales depuis le nom d'entreprise.
export function getInitials(name) {
  if (!name) return 'CS';
  const words = String(name).trim().split(/\s+/).slice(0, 2);
  return words.map(w => w[0] || '').join('').toUpperCase() || 'CS';
}

// Échappement CSV.
export function csvEscape(v) {
  if (v === null || v === undefined) return '';
  const s = String(v);
  if (/[",;\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

// ============ Composant ============

